export default __webpack_public_path__ + "static/media/onlinePrivacyNotice.5c6cf88b.pdf";